import React, { useEffect } from 'react';
import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals';

interface PerformanceMonitorProps {
  onMetricUpdate?: (metric: any) => void;
}

const PerformanceMonitor: React.FC<PerformanceMonitorProps> = ({ onMetricUpdate }) => {
  useEffect(() => {
    // Monitor Core Web Vitals
    const reportWebVital = (metric: any) => {
      // Log to console for development
      if (process.env.NODE_ENV === 'development') {
        //console.log(`📊 Web Vital: ${metric.name} = ${metric.value}`);
      }
      
      // Send to analytics if callback provided
      if (onMetricUpdate) {
        onMetricUpdate(metric);
      }
      
      // Send to Google Analytics if available
      if (typeof window !== 'undefined' && (window as any).gtag) {
        (window as any).gtag('event', metric.name, {
          event_category: 'Web Vitals',
          event_label: metric.id,
          value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
          non_interaction: true,
        });
      }
    };

    // Initialize all web vitals monitoring
    getCLS(reportWebVital);
    getFID(reportWebVital);
    getFCP(reportWebVital);
    getLCP(reportWebVital);
    getTTFB(reportWebVital);

    // Monitor additional performance metrics
    const observePerformance = () => {
      // Monitor long tasks
      if ('PerformanceObserver' in window) {
        const longTaskObserver = new PerformanceObserver((list) => {
          for (const entry of list.getEntries()) {
            if (entry.duration > 50) { // Tasks longer than 50ms
              console.log(`⚠️ Long task detected: ${entry.duration}ms`);
            }
          }
        });
        
        try {
          longTaskObserver.observe({ entryTypes: ['longtask'] });
        } catch (e) {
          console.log('Long task monitoring not supported');
        }
      }

      // Monitor memory usage (if available)
      if ('memory' in performance) {
        const memory = (performance as any).memory;
        //console.log(`💾 Memory: ${Math.round(memory.usedJSHeapSize / 1024 / 1024)}MB used / ${Math.round(memory.jsHeapSizeLimit / 1024 / 1024)}MB limit`);
      }
    };

    // Wait for page to load before monitoring
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observePerformance);
    } else {
      observePerformance();
    }

    // Monitor page visibility changes
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log('📱 Page hidden');
      } else {
        console.log('📱 Page visible');
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [onMetricUpdate]);

  return null; // This component doesn't render anything
};

export default PerformanceMonitor; 